import { create } from "zustand";
import { persist } from "zustand/middleware";
import { SidebarState } from "../lib/types/common";

interface LayoutState {
  isFullscreen: boolean;
  sidebarState: SidebarState;

  // Actions
  setSidebarState: (state: SidebarState) => void;
  toggleFullscreen: (fullScreen?: boolean) => void;
}

export const useLayoutStore = create<LayoutState>()(
  persist(
    (set) => ({
      // Initial Layout State
      isFullscreen: false,
      sidebarState: "expanded",

      // Actions
      setSidebarState: (state) => set({ sidebarState: state }),
      toggleFullscreen: (fullScreen) =>
        set((state) => ({
          isFullscreen:
            typeof fullScreen === "boolean" ? fullScreen : !state.isFullscreen,
        })),
    }),
    {
      name: "layout-storage",
    }
  )
);
